// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IIPItem,
}                               from '../interfaces';

// ===== Enums =====

import {
    BROWSER_TYPE,
}                               from '../enums';

const startUserSession = async ({
    test,
    browser,
    isMobile,
    isMacOS,
    ip,
}: {
    test: boolean,
    browser: BROWSER_TYPE,
    isMobile: boolean,
    isMacOS: boolean,
    ip: IIPItem,
}): Promise<string> => {
    const functions = getFunctions();
    const handleStartUserSession = httpsCallable<
        Record<
            string,
            boolean | BROWSER_TYPE | IIPItem
        >,
        string
    >(
        functions,
        'startUserSession',
    );
    return handleStartUserSession({
        test,
        browser,
        isMobile,
        isMacOS,
        ip,
    }).then((result) => {
        const sessionId = result.data as string;
        return sessionId;
    }).catch((err) => {
        throw err;
    });
};

export default startUserSession;
